import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SpinnerService {
  status$: Observable<boolean>;

  private subject = new BehaviorSubject<boolean>(false);
  private requestCount = 0;

  constructor() {
    this.status$ = this.subject.asObservable();
  }

  display() {
    Promise.resolve().then(() => {
      this.requestCount += 1;
      this.subject.next(true);
    });
  }

  hide() {
    Promise.resolve().then(() => {
      this.requestCount -= 1;
      if (this.requestCount === 0) {
        this.subject.next(false);
      }
    });
  }
}
